export default function LoadingPage() {
  return <div className="loading-page" role="status"><div className="loading-spinner" aria-hidden="true"/><span>Уншиж байна...</span></div>;
}
